import { Component, OnInit, Input } from '@angular/core';
import $ from 'jquery';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-inner',
  templateUrl: './header-inner.component.html',
  styleUrls: ['./header-inner.component.css']
})
export class HeaderInnerComponent implements OnInit {

  imagesUrl = environment.imagesUrl;
  @Input() logoImg: string;

  @Input() navItemList: any[];

  @Input() className: string;

  @Input() styledLogo = true;

  @Input() logoWhite: string;
  @Input() logoClass: string;

  constructor() { }

  ngOnInit() {
  }

  jumpTo(href) {
    $('html, body').stop().animate({
      scrollTop: $(href).offset().top
    }, 1500);
  }

  toggleClass() {
    $(".menu-btn").click(function () {
      $(this).toggleClass("is-active");
    });
  }

}
